var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('iframe',{staticStyle:{"width":"100%","height":"88vh"},attrs:{"src":"http://35.234.202.1"}})])}]

export { render, staticRenderFns }